import { render } from "./AfterAssessmentResult.vue?vue&type=template&id=6750019e"
import script from "./AfterAssessmentResult.vue?vue&type=script&lang=js"
export * from "./AfterAssessmentResult.vue?vue&type=script&lang=js"

import "./AfterAssessmentResult.vue?vue&type=style&index=0&id=6750019e&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__